import { useEffect, useState } from "react";
import axios from "axios";
import Marquee from "react-fast-marquee";
import { ArrowUp, ArrowDown, Minus } from "lucide-react";
import { formatPrice } from "../lib/price";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Re-fetches centralized prices every 20s so admin edits propagate everywhere.
export const LiveRatesTicker = ({ refreshKey = 0 }) => {
  const [prices, setPrices] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await axios.get(`${API}/prices`);
        if (alive) setPrices(res.data);
      } catch (err) {
        console.warn("[LiveRatesTicker] /api/prices fetch failed:", err);
      }
    };
    load();
    const id = setInterval(load, 20000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [refreshKey]);

  if (!prices.length) {
    return (
      <div
        data-testid="live-rates-ticker"
        className="border-b border-black/5 bg-[#fff8f3] py-2.5 text-center font-mono-industrial text-[11px] uppercase tracking-[0.2em] text-[#8b8b8f]"
      >
        Loading live rates…
      </div>
    );
  }

  return (
    <div
      data-testid="live-rates-ticker"
      className="relative border-b border-black/5 bg-gradient-to-r from-[#fff8f3] via-white to-[#fff8f3] py-3"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-white to-transparent" />
      <div className="absolute left-4 top-1/2 z-20 -translate-y-1/2 md:left-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-[#e85a1c] px-3 py-1 font-mono-industrial text-[9px] font-bold uppercase tracking-[0.25em] text-white">
          <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-white" />
          Live
        </span>
      </div>
      <div className="pl-20 md:pl-28">
        <Marquee speed={55} gradient={false} pauseOnHover>
          {prices.concat(prices).map((p, i) => (
            <div
              key={`${p.brand}-${i}`}
              className="mx-6 flex items-center gap-3 font-mono-industrial text-sm"
            >
              <span className="text-[#8b8b8f]">{p.brand}</span>
              <span className="font-bold text-[#1c1c1e]">
                ₹{formatPrice(p.price)}
              </span>
              <span
                className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-xs ${
                  p.trend === "up"
                    ? "bg-emerald-50 text-emerald-700"
                    : p.trend === "down"
                      ? "bg-red-50 text-red-700"
                      : "bg-black/5 text-[#8b8b8f]"
                }`}
              >
                {p.trend === "up" ? (
                  <ArrowUp size={11} />
                ) : p.trend === "down" ? (
                  <ArrowDown size={11} />
                ) : (
                  <Minus size={11} />
                )}
                {p.change > 0 ? "+" : ""}
                {p.change}%
              </span>
              <span className="text-black/10">|</span>
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default LiveRatesTicker;
